import { MockedRequest, ResponseResolver, restContext, RestRequest } from 'msw';
import { delayedResponse } from '@/utils/useMswCustomResponse';
import { choiceRandom } from '@/utils/useHelper';

// 仮申込の入力補完を取得する
const getPreApplicationSuggestions: ResponseResolver<
  RestRequest,
  typeof restContext
> = (req, res, ctx) => {
  const parkingId = req.url.searchParams.get('parkingId');
  const applicationId = req.url.searchParams.get('applicationId');
  return delayedResponse(
    ctx.status(200),
    ctx.json({
      member: {
        id: 1,
        userId: 101,
        lastName: '山田',
        firstName: '太郎',
        lastNameKana: 'ヤマダ',
        firstNameKana: 'タロウ',
        phoneNumber: ['080', '1234', '5678'],
        zipCode: '123-4567',
        gender: 1,
        birthday: '1990-01-01T00:00:00Z',
        prefecture: '東京都',
        city: '渋谷区',
        streetAddress: '1-2-3',
        building: '渋谷ハイツ',
        emails: ['yamada.taro@example.com', 'yamada.taro2@example.com'],
      },
      corporateAccount: {
        id: 10,
        name: 'ナビパーク株式会社',
        nameKana: 'ナビパークカブシキガイシャ',
        zipCode: '150-0002',
        addressRegion: '東京都',
        addressLocality: '渋谷区',
        addressStreet: '渋谷2-21-1',
        addressBuilding: '渋谷スクランブルスクエア',
        phoneNumber: ['03', '1234', '5678'],
        emails: ['corp@example.com', 'corp2@example.com'],
      },
      selectableStartDates: ['2023-01-01', '2023-01-15', '2023-02-01'],
    }),
  );
};

// 仮申込申請
const postPreApplication: ResponseResolver<
  MockedRequest,
  typeof restContext
> = async (req, res, ctx) => {
  if (choiceRandom([true, false])) {
    return delayedResponse(ctx.status(201), ctx.json({ applicationId: 1 }));
  } else {
    return delayedResponse(
      ctx.status(400),
      ctx.json({
        messages: ['エラーメッセージ'],
        code: 213,
      }),
    );
  }
};

// 法人仮申込申請
const postCorporatePreApplication: ResponseResolver<
  RestRequest,
  typeof restContext
> = async (req, res, ctx) => {
  return delayedResponse(
    ctx.status(201),
    ctx.json({
      applicationId: 10,
    }),
  );
};

const mockPreApplication = {
  getPreApplicationSuggestions,
  postPreApplication,
  postCorporatePreApplication,
};

export default mockPreApplication;
